module.exports = "/static/assets/eaac6d02ce53941bd74e654f61e82970.png";